import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { EventosPage } from '../pages/EventosPage';
import '../styles.css';

const container = document.getElementById('app')!;
createRoot(container).render(
  <StrictMode>
    <EventosPage />
  </StrictMode>,
);
